import type { VFC } from 'react';
import { Flex } from 'antd';
import { Card } from 'components';
import { useMeterModels } from 'api/hooks/meter-models/useMeterModels';
import { ModelListFilter } from './components/Filter';
import { useModelsListFilterWithPagination } from './hooks/useModelsListFilterWithPagination';
import { ModelsTable } from './components/Table';

export const ModelsList: VFC = () => {
  // State
  const { filter, pagination, setPaginationState } = useModelsListFilterWithPagination();

  // Fetch
  const { data: modelsResponse, isFetching: isFetchingModels } = useMeterModels(
    {
      ...(filter?.search && { search: filter?.search }),
      ...(filter?.commodity && { commodity: filter.commodity }),
      ...(filter?.manufacturerId && { manufacturerId: filter.manufacturerId }),
      ...(filter?.technologies && { technologies: filter.technologies }),
      populate: ['manufacturer'],
      sort: filter?.sort,
      page: pagination.current,
      pageSize: pagination.pageSize,
    },
    {
      onSuccess: data => {
        setPaginationState({ total: data?.meta?.pagination?.total });
      },
    },
  );

  return (
    <Flex vertical gap={16}>
      <Card>
        <ModelListFilter />
      </Card>

      <Card>
        <ModelsTable isFetchingModels={isFetchingModels} modelsData={modelsResponse?.data ?? []} />
      </Card>
    </Flex>
  );
};
